<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Td0lKK/tc-custom/9781426870347.jpg?1704481970539" alt="This image is the cover for the book Mac's Bedside Manner, The Bachelors of Blair Memorial"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mac's Bedside Manner, The Bachelors of Blair Memorial
      </h1>
      <p class="bookDescription body article font2">
        <i><b>HOW TO CATCH A BACHELOR</b></i><br/><br/>With his killer smile, his bone-melting charmand his medical dedication, hospital hunkDr. Harrison "Mac" Mackenzie couldthaw an iceberg at twenty paces.<br/><br/>Collecting willing women like baseballcards, he hadn't met resistance sincehigh school physics. Until feisty nurseJolene DeLuca sashayed into the E.R.,with her perfect curves, her flashinggreen eyes-and an attitude that toldbig-deal doctors to drop dead!<br/><br/>Mac was intrigued. Challenged. Andutterly enchanted by spitfire Jolene and her daddylesstwo-year-old daughter. But what was a confirmedbachelor to do with such a skittish single mom? Chaseher...until she caught him!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Ferrarella
      </h2>
      
      <p class="authorDescription body article">This USA TODAY bestselling and RITA &reg; Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e4e34e9